export const PYMT_SECURITY_CARD = 'card_treatment';
export const PYMT_SECURITY_PAGE = 'page_treatment';
export const PYMT_SECURITY_CTRL = 'control';
export const PYMT_SECURITY_EXCLUDED_STATES = ['MS', 'AA', 'AB', 'AE', 'AP', 'AS', 'BC', 'CZ', 'FC', 'FM', 'GU', 'MB', 'MP', 'NB', 'ON', 'PE', 'QC', 'SA', 'SK', 'VI'];
